// extracted by mini-css-extract-plugin
export default {"link":"NavigationButton_link__RquAI","btnSlide":"NavigationButton_btnSlide__T6Kos"};